import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { PostmethodService } from '../../app-config/postmethod.service';

@Injectable({
  providedIn: 'root',
})
export class CustomerInterestService {
  constructor(private ws: PostmethodService) {}

  getCustomerInterestMaster(): Observable<any> {
    const requestPayload = { flag: 'list' };
    return this.ws.wsPost(
      requestPayload,
      environment.masterUrl + 'customerInterestMaster'
    );
  }

  createCustomerInterestMaster(data: any): Observable<any> {
    const requestPayload = { ...data, flag: 'create' };
    return this.ws.wsPost(
      requestPayload,
      environment.masterUrl + 'customerInterestMaster'
    );
  }

  updatecustomerInterestMaster(id: number, data: any): Observable<any> {
    const requestPayload = { ...data, flag: 'update', id };
    return this.ws.wsPost(
      requestPayload,
      environment.masterUrl + 'customerInterestMaster'
    );
  }
}
